export const usePx = (str) => {
  const { browser } = useStores()

  return computed(() => {
    if (!str.value) return 0

    const num = parseFloat(str.value)

    if (str.value.indexOf("px") >= 0) {
      return num
    } else if (str.value.indexOf("rem") >= 0) {
      return num * browser.fontSize
    }

    return 0
  })
}
